export class SignInDto {
    public usernameOrEmail;
    public password;
    public google;
    public facebook;
    public accessToken;

    constructor() {
    }
}